import { KnowledgeBaseVisibilityType } from 'types/KnowledgeBaseVisibilityType'

const defaultValues = {
  files: [],
  visibility: KnowledgeBaseVisibilityType.Company
}

export {
  defaultValues,
}
